export const RegExpTimesheetHours = /^(1[0-9]{0,1}|2[0-4]{0,1}|[0-9]{0,1})(\.\d{0,2})?%?$/;
export const RegExpSysParam = /[a-zA-Z0-9.]+/;
export const RegExpNoSpecial: RegExp = /^[^<>*!]+$/;
export const RegExpPositiveInteger: RegExp = /^[0-9]\d*$/;

//export const RegExp2DigitDecimal: RegExp = /^\d+\.\d{0,2}$/
// Roop: Updated the Regexp for 2 digit decimal Source: https://www.regextester.com/106500
export const RegExp2DigitDecimal: RegExp = /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/;

// annual salary 10 digits for whole part
export const RegExpAnnualSalary: RegExp = /^[0-9]{0,10}(\.[0-9]{1,2})?$/;

// hourly salary 7 digits for whole part
export const RegExpHourlySalary: RegExp = /^[0-9]{0,7}(\.[0-9]{1,2})?$/;


// +- 9999.99 hours in a year
export const RegExp4DigitInteger2DigitFraction: RegExp = /^[-+]?[0-9]{0,4}(\.[0-9]{1,2})?$/;

export const RegExp3DigitInteger2DigitFraction: RegExp = /^[-+]?[0-9]{0,3}(\.[0-9]{1,2})?$/;
export const RegExp8DigitInteger2DigitFraction: RegExp = /^[-+]?[0-9]{0,8}(\.[0-9]{1,2})?$/;
export const RegExp12DigitInteger2DigitFraction: RegExp = /^[-+]?[0-9]{0,12}(\.[0-9]{1,2})?$/;
export const RegExp7DigitInteger2DigitFraction: RegExp = /^[-+]?[0-9]{0,7}(\.[0-9]{1,2})?$/;

export const RegExp5DigitDecimal: RegExp = /^[0-9]{0,2}(\.[0-9]{1,5})?$|^(100)(\.[0]{1,5})?$/;

export const RegExp4DigitDecimal: RegExp = /^[0-9]{0,2}(\.[0-9]{1,4})?$|^(100)(\.[0]{1,4})?$/;

export const RegExpEmail: RegExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const RegExpEmailWithAlias: RegExp = /^[\w-\+.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const RegExpWebsite: RegExp = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/.|www\.)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

export class RegEx {
  static TimesheetHours = /^(1[0-9]{0,1}|2[0-4]{0,1}|[0-9]{0,1})(\.\d{0,2})?%?$/;
  static SysParam = /[a-zA-Z0-9.]+/;
  static NoSpecial: RegExp = /^[^<>*!]+$/;
  static PositiveInteger: RegExp = /^[0-9]\d*$/;

  // Roop: Updated the Regexp for 2 digit decimal Source: https://www.regextester.com/106500
  static Num2DigitDecimal: RegExp = /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/;

  // annual salary 10 digits for whole part
  static AnnualSalary: RegExp = /^[0-9]{0,10}(\.[0-9]{1,2})?$/;

  // hourly salary 7 digits for whole part
  static HourlySalary: RegExp = /^[0-9]{0,7}(\.[0-9]{1,2})?$/;


  // +- 9999.99 hours in a year
  static Num4DigitInteger2DigitFraction: RegExp = /^[-+]?[0-9]{0,4}(\.[0-9]{1,2})?$/;

  static Num3DigitInteger2DigitFraction: RegExp = /^[-+]?[0-9]{0,3}(\.[0-9]{1,2})?$/;
  static Num12DigitInteger2DigitFraction: RegExp = /^[-+]?[0-9]{0,12}(\.[0-9]{1,2})?$/;
  static Num7DigitInteger2DigitFraction: RegExp = /^[-+]?[0-9]{0,7}(\.[0-9]{1,2})?$/;

  static Num5DigitDecimal: RegExp = /^[0-9]{0,2}(\.[0-9]{1,5})?$|^(100)(\.[0]{1,5})?$/;

  static Num4DigitDecimal: RegExp = /^[0-9]{0,2}(\.[0-9]{1,4})?$|^(100)(\.[0]{1,4})?$/;

  static Email: RegExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  static Website: RegExp = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/.|www\.)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

}
